/* eslint-disable */
import { EventBus } from '@/event'
import { mVMixin } from '@/mixins'

const releaseType = BUILDTYPE == 'PROD' ? 'prodv2' : 'betav1'

export const output = {
    state: {
        baseUrl: `https://vtranscode.mobiotics.com/${releaseType}/transcoder/v1`,
        auth: `Bearer ${localStorage.getItem('token')}`
    },
    actions: {
        getTranscodJobById(context, jobId) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            }
            EventBus.$emit('Loader', true)
            return new Promise(function(resolve, reject) {
                fetch(`${context.state.baseUrl}/jobs/${jobId}`, requestOptions)
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },
        getTranscodedList(context, data) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            myHeaders.append('Content-Type', 'application/json')
            let requestOptions = {
                method: 'GET',
                headers: myHeaders,
                redirect: 'follow'
            }
            let params = `${mVMixin.methods.getParam(data)}`
            EventBus.$emit('Loader', true)
            return new Promise(function(resolve, reject) {
                fetch(`${context.state.baseUrl}/jobs?${params}`, requestOptions)
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        },

        actDeleteTranscoder(context, jobId) {
            let myHeaders = new Headers()
            let token = localStorage.getItem('token') ? localStorage.getItem('token') : ''
            myHeaders.append('Authorization', `Bearer ${token}`)
            myHeaders.append('Content-Type', 'application/json')
            let requestOptions = {
                method: 'DELETE',
                headers: myHeaders
            }
            EventBus.$emit('Loader', true)
            return new Promise((resolve, reject) => {
                fetch(`${context.state.baseUrl}/jobs/${jobId}`, requestOptions)
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        console.log(error)
                    })
            })
        },


        reInitiateTranscoding(context, data) {
            EventBus.$emit('Loader', true)
            return new Promise(function(resolve, reject) {
                fetch(`${context.state.baseUrl}/jobs/${data.jobId}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': context.getters.getAuthToken,
                        },
                        method: 'PUT',
                        body: JSON.stringify(data.content)
                    })
                    .then(response => {
                        EventBus.$emit('Loader', false)
                        if (response.ok) {
                            resolve(response.json())
                        } else {
                            resolve(response.json())
                        }
                    }).catch(error => {
                        EventBus.$emit('Loader', false)
                        reject(error)
                    })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/output.js